(() => {
  const init = (root = document) => {
    root.querySelectorAll('variant-selects:has([data-pause-choice])').forEach(picker => {
      if (picker.dataset.pauseSelectorReady) return;
      const data = picker.querySelector('script[type="application/json"]');
      if (!data) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      picker.dataset.pauseSelectorReady = 'true';
      const fields = [...picker.querySelectorAll('[data-pause-choice]')];
      const selected = () => fields.map(field => field.querySelector('input:checked')?.value);
      const refresh = () => {
        const values = selected();
        fields.forEach((field, index) => {
          field.querySelectorAll('input[type="radio"]').forEach(input => {
            const candidates = variants.filter(v => v.options[index] === input.value);
            const matches = candidates.filter(v => v.options.every((value, i) => i === index || value === values[i]));
            input.classList.toggle('disabled', !(matches.length ? matches : candidates).some(v => v.available));
            const label = input.nextElementSibling;
            const match = matches.find(v => v.featured_image) || candidates.find(v => v.featured_image);
            const source = match?.featured_image?.src;
            let img = label.querySelector('img');
            if (source && !field.classList.contains('pause-choice--diameter')) {
              if (!img) { img = document.createElement('img'); img.className='pause-choice__image'; img.alt=''; img.width=72; img.height=72; label.prepend(img); }
              const url = new URL(source, location.origin);
              url.searchParams.set('width','144');
              img.removeAttribute('srcset');
              if (img.src !== url.href) img.src = url.href;
            }
          });
          const input = field.querySelector('input:checked');
          const summary = field.querySelector('summary');
          if (!summary || !input) return;
          summary.querySelector('[data-pause-choice-value]').textContent = input.value;
          const img = input.nextElementSibling.querySelector('img');
          summary.querySelector('.pause-choice__selected-image').replaceChildren(...(img ? [img.cloneNode(true)] : []));
        });
      };
      picker.addEventListener('change', event => {
        const field = event.target.closest('[data-pause-choice]');
        if (!field) return;
        const index = fields.indexOf(field);
        const values = selected();
        if (!variants.some(v => v.options.every((value,i) => value === values[i]))) {
          const candidates = variants.filter(v => v.options[index] === values[index]);
          const score = v => v.options.reduce((sum,value,i) => sum + (value === values[i] ? 4 : 0),v.available ? 1 : 0);
          const next = candidates.reduce((best,v) => !best || score(v) > score(best) ? v : best,null);
          if (next) fields.forEach((other,i) => {const input=[...other.querySelectorAll('input')].find(node=>node.value===next.options[i]);if(input)input.checked=true;});
        }
      }, true);
      picker.addEventListener('change', event => {
        const details = event.target.closest('.pause-choice__dropdown');
        if (details) { details.open=false; details.querySelector('summary').focus({preventScroll:true}); }
        refresh();
      });
      picker.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details');
        if (details?.open) {details.open=false;details.querySelector('summary').focus({preventScroll:true});event.stopPropagation();}
      });
      picker.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          picker.querySelectorAll('details').forEach(other => {if(other!==details)other.open=false;});
          const list=details.querySelector('.pause-choice__options');
          const label=details.querySelector('input:checked + label');
          if(list && label)list.scrollTop=Math.max(0,label.offsetTop-list.clientHeight/2+label.clientHeight/2);
        });
      });
      document.addEventListener('click',event=>{if(!picker.contains(event.target))picker.querySelectorAll('details[open]').forEach(details=>{details.open=false;});});
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
